import { English } from './English';
import { French } from './French';

let properties = {};
// properties = French;
// if(
//     localStorage.getItem('selectedLang') === properties.defalutLangText ||
//     localStorage.getItem('selectedLang') === null
// ){
    properties = English;
//}

export { properties };